import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import * as googleHelpers from 'util/google-helpers';

export function usePageViews() {
  let location = useLocation();
  useEffect(() => {
    const isPartnerPage = /\/partner-pavilion\/partner\/\w+/.test(location.pathname);

    // Don't log if it's a Partner page, as we'll log that in the PartnerDetail component
    if (!isPartnerPage) {
      googleHelpers.trackGooglePage(location.pathname);
    }
  }, [location]);
}
